module.exports = __webpack_public_path__ + "img/lexprogress-video-heart.6863e394.svg";